module.exports = __webpack_public_path__ + "assets/refresh.5524379c.svg";